import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { frontendserverurl } from '../../../../../environments/environment';
import { inject } from '@angular/core';
import { GenericStreamsService } from '../../../../service/generic-streams.service';
import { StreamOrderItem } from '../../../../interfaces/generic-streams';

interface StreamObject {
    id: string;
    name: string;
    categoryId: string[];
}


@Component({
    selector: 'app-package-item',
    standalone: false,
    templateUrl: './package-item.component.html',
    styleUrl: './package-item.component.scss'
})
export class PackageItemComponent {
    protected streamService = inject(GenericStreamsService);
    @Input() category: any;
    @Input() streams: StreamObject[] = [];
    @Input() streamOrder: StreamOrderItem[] = [];
    @Output() changeStreamsOrder = new EventEmitter<any>();
    @Output() deletePackage = new EventEmitter<any>();
    @Output() editPackage = new EventEmitter<any>();

    filteredStreams: StreamObject[] = [];
    frontendurl = frontendserverurl;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['category']) {
            this.category = changes['category'].currentValue;
            console.log("Package:", this.category)
        }
        if (changes['streams']) {
            this.streams = changes['streams'].currentValue as StreamObject[];
            // this.filterStreams()
        }
        if (changes['streamOrder']) {
            this.streamOrder = changes['streamOrder'].currentValue as StreamOrderItem[];
            this.filterStreams()
        }
    }

    filterStreams() {
        if (this.category && this.streams) {
            for (const cat of this.streamOrder) {
                if (cat.categoryId === this.category.id) {
                    const stream = this.streams.find(s => s.id === cat.streamId);
                    if (stream) {
                        this.filteredStreams.push(stream);
                    }
                }
            }
        }
        // this.filteredStreams = this.streams.filter(stream => stream.categoryId.includes(this.category.id));
    }

    async drop(event: any) {
        moveItemInArray(this.filteredStreams, event.previousIndex, event.currentIndex);
        let updatedOrders = this.filteredStreams.map((item: any, index: any) => ({
            categoryId: this.category.id,
            streamId: item["id"],
            orderNr: index,
        }));
        // this.changeStreamsOrder.emit({ streams: updatedOrders, categoryId: this.category.id });
        await this.streamService.emitStreamOrderChanges(updatedOrders);
    }
}
